<template>
  
  <div class="gallery">
    
    <div
      ref="container"
      :style="{
        'transform' : `translateX(${ -100 * activeIndex }%)`,
        'transition-duration' : '400ms'
      }"
      class="gallery__container"
    >
      
      <div
        v-for="image in images"
        class="gallery__image-wrapper"
      >
        
        <div
          :style="{ 'background-image' : `url(${ image })` }"
          class="gallery__image"
        ></div>

      </div>

    </div>

    <div class="gallery__pagination">
      
      <div
        v-for="(number, index) in countImages"
        @click="onClickPaginationItem(index)"
        :class="{ 'gallery__pagination-item_active' : index === activeIndex}"
        class="gallery__pagination-item"
      ></div>

    </div>

    <div
      @click="onClickControl"
      class="gallery__control"
    ></div>

  </div>

</template>

<script>
  import Utils from '@/mixins/Utils';

  export default {
    name: 'GalleryImages',

    mixins: [
      Utils,
    ],

    props: {
      images: {
        type: Array,
        default: [],
      },
    },

    data() {
      return {
        activeIndex: 0,
      };
    },

    computed: {
      countImages() {
        let result = null;

        if (this.isMobile) {
          result = this.images.length;
        } else {
          result = this.images.length - 2;
        }

        return result;
      },
    },

    watch: {
      isMobile(bool) {
        if (bool) {
          this.removeClones();
          this.$refs.container.removeEventListener(
            'transitionend',
            this.onTransitionEnd
          );
        } else {
          this.addClones();
          this.$refs.container.addEventListener(
            'transitionend',
            this.onTransitionEnd
          );
        }
      },
    },

    created() {
      if (!this.isMobile) {
        this.addClones();
      }
    },

    mounted() {
      if (!this.isMobile) {
        this.$refs.container.addEventListener(
          'transitionend',
          this.onTransitionEnd
        );
      }
    },

    methods: {
      addClones() {
        const cloned = this.images.slice(0, 2);
        this.images.push(...cloned);
      },

      removeClones() {
        this.images.splice(-2, 2);
      },

      onTransitionEnd() {
        if (this.activeIndex === this.countImages) {
          this.$refs.container.style.transitionDuration = '0ms';
          this.activeIndex = 0;

          // @todo
          // Так себе решение. Нужно разобраться почему анимация происходит,
          // если duration равно 0.
          setTimeout(() => {
            this.$refs.container.style.transitionDuration = '400ms';
          }, 50);
        }
      },

      onClickPaginationItem(index) {
        this.activeIndex = index;
      },

      onClickControl() {
        this.nextImage();
      },

      nextImage() {
        const currentIndex = this.activeIndex;
        const countImages = this.countImages;
        const nextIndex = currentIndex + 1;

        this.activeIndex = nextIndex > countImages - 1
          ? this.isMobile
            ? 0
            : countImages
          : nextIndex;
      },

      prevImage() {
        const currentIndex = this.activeIndex;
        const countImages = this.countImages;
        const nextIndex = currentIndex - 1;

        this.activeIndex = nextIndex < 0
          ? countImages - 1
          : nextIndex;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/GalleryImages.vue